import { Entity, Color } from 'playcanvas';
import { RESOLUTION_FIXED, RESOLUTION_AUTO, SHADOW_PCF5_16F } from 'playcanvas';


const RESOLUTION = 256;
const FORMAT = 'image/webp';


const render = (app, callback) => {
    const canvas = app.graphicsDevice.canvas;


    // set image resolution
    app.setCanvasResolution(RESOLUTION_FIXED, RESOLUTION, RESOLUTION);


    // configure camera
    const cameraEntity = app.root.findByName('camera');
    cameraEntity.script.camera.forcePortrait = true;
    const fovBefore = cameraEntity.camera.fov;


    // hide skybox
    const layerSkybox = app.scene.layers.getLayerByName('Skybox');
    layerSkybox.enabled = false;


    // set up lights

    //      light orange
    const lightAccentA = new Entity('light');
    lightAccentA.addComponent('light', {
        type: 'directional',
        intensity: 4,
        color: new Color(1, 0.5, 0),
        castShadows: true,
        shadowType: SHADOW_PCF5_16F,
        shadowResolution: 2048,
        shadowDistance: 4,
        shadowBias: 0.01,
        normalOffsetBias: 0.01
    });
    lightAccentA.setLocalEulerAngles(90, 230, 0);
    cameraEntity.addChild(lightAccentA);

    //      light blue
    const lightAccentB = new Entity('light');
    lightAccentB.addComponent('light', {
        type: 'directional',
        intensity: 10,
        color: new Color(0, 0.5, 1),
        castShadows: true,
        shadowType: SHADOW_PCF5_16F,
        shadowResolution: 2048,
        shadowDistance: 4,
        shadowBias: 0.01,
        normalOffsetBias: 0.01
    });
    lightAccentB.setLocalEulerAngles(60, 130, 0);
    cameraEntity.addChild(lightAccentB);


    // need to wait for the rendering to happen
    app.once('postrender', () => {
        // get WEBP
        const dataUrl = canvas.toDataURL(FORMAT);

        // reset camera back
        cameraEntity.script.camera.forcePortrait = false;
        cameraEntity.camera.fov = fovBefore;
        
        // show skybox back
        layerSkybox.enabled = true;

        // remove lights
        lightAccentA.destroy();
        lightAccentB.destroy();

        // reset renderer to auto resolution
        app.setCanvasResolution(RESOLUTION_AUTO);

        if (callback) callback(dataUrl);
    });
};

export { render };